<template>
  <Layout
    v-if="isMedia || routePanorama"
    class="MediaView"
    :color-classes="colorClasses"
    :full-size="isFullsize"
  >
    <Panorama
      v-if="routePanorama"
      :pano-obj="routePanorama"
    />
    <div
      v-else-if="routeMedia"
      class="w-full max-w-200 mx-auto"
    >
      <Article
        v-if="routeMedia.type === 'article'"
        :post="routeMedia"
      />
      <Gallery
        v-else-if="routeMedia.type === 'gallery'"
        :post="routeMedia"
      />
      <Video
        v-else-if="routeMedia.type === 'video'"
        :post="routeMedia"
      />
      <MediaTitle :post="routeMedia" />
      <div
        v-if="routeMedia.body"
        class="tiny-mce mt-6"
        v-html="wysiwygFilter(routeMedia.body)"
      />
    </div>
    <!-- Contentspots -->
    <transition name="fade">
      <router-view />
    </transition>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Panorama from '@/components/Panorama.vue'
import Article from '@/components/Article.vue'
import Gallery from '@/components/Gallery.vue'
import Video from '@/components/Video.vue'
import MediaTitle from '@/components/MediaTitle.vue'
import { loadKrp } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'Media',

  mixins: [ loadKrp ],

  components: {
    Layout,
    Panorama,
    Article,
    Gallery,
    Video,
    MediaTitle
  },

  computed: {
    ...mapGetters([
      'routeAoi',
      'routeMedia',
      'routePanorama',
      'myStore',
    ]),
    isSinglePanorama() { return (this.$route.params || {}).media_id === 'single' },
    isPanorama() { return ['group'].includes((this.routeMedia || {}).type) || this.routePanorama || this.isSinglePanorama },
    isMedia() { return this.routeMedia || this.isSinglePanorama },
    isFullsize() { return (this.isPanorama) ? true : false },
    // Styles
    mediaStyles() { return this.myStore(['styles', 'media_screens']) ?? {} },
    colorClasses() {
      const classArr = []
      // Bg
      const bgStyles = this.mediaStyles.background ?? {}
      const bgClass = bgStyles.bg_color && `bg-${bgStyles.bg_color}`
      if (bgClass) { classArr.push(bgClass) }
      // Text
      const bodyStyles = this.mediaStyles.body_copy ?? {}
      const textClass = bodyStyles.text_color && `text-${bodyStyles.text_color}`
      if (textClass) { classArr.push(textClass) }
      return classArr.join(' ')
    },
  },

  watch: {
    routeMedia() { this.updatePageMeta() }
  },

  created() {
    this.updatePageMeta()
  },

  methods: {
    updatePageMeta() {
      // Panorama title managed in Panorama component
      if (this.isPanorama || !this.routeMedia) { return }
      const newPageMeta = { pageTitle: this.routeMedia.title }
      if (this.routeAoi) { newPageMeta.parentTitle = this.routeAoi.title }
      this.$store.commit('pageMeta', newPageMeta)
    }
  }
}
</script>

